export const SUPPORT_MASTHEAD_HEIGHT = 60;
export const SUPPORT_FAVICON_HREF = './favicons/support.svg';
